import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation changeCurrencyMutation($input: EditPersonalProfileInput!) {
        editPersonalProfile(input: $input) {
            user {
                profile {
                    currency
                }
            }
        }
    }
`;

const getOptimisticResponse = (id, currency) => ({
    editPersonalProfile: {
        user: {
            id,
            profile: {
                currency,
            },
        },
    },
});

export function changeCurrencyMutation({ environment, user, currency, onCompleted }) {
    const { id, serviceId } = user;

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                userServiceId: serviceId,
                currency: currency,
            },
        },
        optimisticResponse: getOptimisticResponse(id, currency),
        onCompleted,
    });
}
